import { render, staticRenderFns } from "./RecWrap.vue?vue&type=template&id=6ede1f58&scoped=true&lang=pug&"
import script from "./RecWrap.vue?vue&type=script&lang=js&"
export * from "./RecWrap.vue?vue&type=script&lang=js&"
import style0 from "./RecWrap.vue?vue&type=style&index=0&id=6ede1f58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ede1f58",
  null
  
)

export default component.exports